export const LOADER_KEY = 'loading_screen_config';
export const LOADER_ACTIVE_REGION = 'mexico';
export const SHOW_LOADER = true;
export const HIDE_LOADER = false;

export const EXCLUDED_PATHS = [
  {
    path: '/pbi',
    exclusionReason:
      'Por temas de usabilidad, se necesita una transicion limpia entre un flujo de compra de la app a webview de la pbi',
  },
  {
    path: '/telmex',
    exclusionReason:
      'No se debe mostrar el loader en el flujo del iframe en moviles para mostrar una transicion limpia al webview',
  },
  {
    path: '/gtres',
  },
  {
    path: '/payment',
  },
  {
    path: '/mundial2026',
  },
  {
    path: '/agregarmdp',
  },
  {
    path: '/editarmdp',
  },
];
